<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">A<span class="epub-sc">CKNOWLEDGMENTS</span></span></p>
<p class="tni">The story “People of the Summit” is a rewritten version of a story by the same title, by Björn Nyberg, in <span class="epub-i">The Mighty Swordsmen</span> (N.Y.: Lancer Books, 1970), copyright © 1970 by Hans Stefan Santesson.</p>
<p class="tx">The article “Hyborian Names” is expanded from the following articles by L. Sprague de Camp: “An Exegesis of Howard’s Hyborian Tales” in <span class="epub-i">Amra,</span> II, 4, 5, and 6, copyright © 1959 by L. Sprague de Camp; “Addenda to the Exegesis” in <span class="epub-i">Amra</span> II, 6, copyright © 1959 by George H. Scithers; “Exegetical Addenda” in <span class="epub-i">Amra,</span> II, 9, copyright © 1960 by George H. Scithers; “Addenda to the Exegesis” in <span class="epub-i">Amra,</span> II, 40, copyright © 1966 by the Terminus, Owlswick, and Ft. Mudge Electrick Street Railway Gazette; “Superaddendum to the Exegesis” in <span class="epub-i">Amra,</span> II, 45, copyright © 1967 by L. Sprague de Camp; “An Exegesis of Howard’s Hyborian Tales” in <span class="epub-i">The Conan Reader</span> (Baltimore: Mirage Press, 1968), copyright © 1968 by L. Sprague de Camp; and “An Exegesis of Names Discarded by REH” in <span class="epub-i">Amra,</span> II, 51, copyright © 1969 by L. Sprague de Camp.</p>
<p class="tx">All the other materials in this volume are published here for the first time.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?6fff6010